import {
  getFirestore,
  doc,
  addDoc,
  getDoc,
  updateDoc,
  collection,
  serverTimestamp,
} from "firebase/firestore";

// Fetch a blog document by ID
export const fetchBlogData = async (blogId) => {
  const db = getFirestore();
  const blogRef = doc(db, "blogs", blogId);
  const blogSnap = await getDoc(blogRef);

  if (blogSnap.exists()) {
    return { id: blogSnap.id, ...blogSnap.data() };
  } else {
    throw new Error("Blog not found");
  }
};

// Save (or update) a draft blog
export const saveBlogDraft = async (blogId, blogData) => {
  const db = getFirestore();

  const data = {
    ...blogData,
    updatedAt: serverTimestamp(),
    status: "draft",
  };

  if (blogId) {
    const blogRef = doc(db, "blogs", blogId);
    await updateDoc(blogRef, data);
    return blogId;
  } else {
    const newRef = await addDoc(collection(db, "blogs"), {
      ...data,
      createdAt: serverTimestamp(),
    });
    return newRef.id;
  }
};

// Publish blog (create or update)
export const publishBlog = async (blogId, blogData) => {
  const db = getFirestore();

  const data = {
    ...blogData,
    updatedAt: serverTimestamp(),
    status: "published",
  };

  if (blogId) {
    const blogRef = doc(db, "blogs", blogId);
    await updateDoc(blogRef, data);
    return blogId;
  } else {
    const newRef = await addDoc(collection(db, "blogs"), {
      ...data,
      createdAt: serverTimestamp(),
    });
    return newRef.id;
  }
};
